import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss']
})
export class DividerComponent implements OnChanges, OnInit {
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Input() color = 'var(--gray-1)';

  @Input() rounded = false;

  @Input() thickness: string | number = '2px';

  style: Record<string, string> = {};

  ngOnChanges(): void {
    this.updateStyle();
  }

  ngOnInit(): void {
    this.updateStyle();
  }

  private normalizeThickness(value: string | number): string {
    if (typeof value === 'number') {
      return `${value}px`;
    }
    return value;
  }

  private updateStyle() {
    const t = this.normalizeThickness(this.thickness);
    const radius = this.rounded ? '9999px' : '0';

    if (this.orientation === 'vertical') {
      this.style = {
        width: t,
        height: '100%',
        'background-color': this.color,
        'border-radius': radius
      };
    } else {
      this.style = {
        height: t,
        width: '100%',
        'background-color': this.color,
        'border-radius': radius
      };
    }
  }
}
